module.exports = __webpack_public_path__ + "img/6534.83c768ec.jpg";